/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Function Init - Global

window.addEventListener('load', function(event) {
  genderToggleInit();
}, true);

// Header Transform Event Listener

const container = document.querySelector("#main");
const header = document.getElementById('top');
const bodyEl = document.querySelector("body");

container.addEventListener('scroll', function() {
    if (container.scrollTop < 100 && header.getAttribute('data-transparent-header') == 'false') {
        header.setAttribute("data-transparent-header", "true");
        bodyEl.classList.remove('header-stuck');
    } else if ( container.scrollTop > 100 && header.getAttribute('data-transparent-header') == 'true' ) {
        header.setAttribute("data-transparent-header", "false");
        bodyEl.classList.add('header-stuck');
    }
});

// Homepage Scroll Button Functionality

$('.hero-image--content_scroll').on( "click", function() {
  document.getElementById('main').scroll({
    behavior: 'smooth',
    left: 0,
    top:  document.getElementById('main').scrollTop + 500
  });
} );

// Navigation Event Listeners

const childMenus = document.querySelectorAll('.mobile-nav__item--sub')

childMenus.forEach((menu) => {

  var submenu = menu.querySelector('.mobile-nav_submenu');
  
  menu.addEventListener('click', () => {

    if (menu.getAttribute('aria-expanded') == 'false') {

      gsap.to(submenu, {
        height:'0',
        opacity: 0,
        duration: 0.3,
       });

    } else {

      gsap.to(submenu, {
        height:'auto',
        opacity: 1,
        duration: 0.3,
       });

    }

  });

  if(menu.getAttribute('href') == '#load') {
    gsap.to(submenu, {
        height:'auto',
        opacity: 1,
        duration: 0.3,
    });
  }

});

// Navigation Sub Menu Back Button

const backbutton = document.querySelectorAll('.js-back-mfp');

backbutton.forEach((button) => {
  button.addEventListener('click', () => {

    var currentNav = button.closest('[data-navigation]');
    var parentmenu = document.querySelector('[data-menu="active"][data-level="1"]');
    

    gsap.to(currentNav, {
      onStart: function() { },
      left:"100%",
      duration: 0.3,
      ease: "none",
      onComplete: function() { }
    });

    gsap.to('[data-menu="active"][data-level="1"], [data-navigation="root"]', {
      onStart: function() { },
      left:"0%",
      duration: 0.3,
      ease: "none",
      onComplete: function() { }
    });
    
  });
});

// Sets size of Carousel on PLP to ensure product form sits perfectly at bottom of page



// Initialise Size Guide Popup

function sizeGuideInit() {

var sizeGuideButtons = document.querySelectorAll(".js-size-guide");

sizeGuideButtons.forEach(button => {
  button.addEventListener('click', function () {
    theme.mfpOpen('product-form');
    });
})

};

// Navigation Menu Submenu Trigger

var radioElem = document.querySelector('.mobile-draw__nav-gender');
var radios = document.querySelectorAll('input[type=radio][name="gender_selection"]');
radios.forEach(radio => {
  radio.addEventListener('change', function(){

    radioElem.setAttribute('aria-toggled', 'true');
  
    var currentMenu = document.querySelector('[data-menu="active"]')
    currentMenu.removeAttribute('data-menu');

    var newMenu = document.querySelector('[data-level="1"][data-name="' + radio.value + '"]');
    newMenu.setAttribute('data-menu', 'active');

    currentMenu.setAttribute('aria-active', 'false');
    newMenu.setAttribute('aria-active', 'true');

    var currentMenupercent;
    var newMenupercent;

    
    if (currentMenu.getAttribute('data-navigation') > newMenu.getAttribute('data-navigation')) {
      var currentMenupercent = '100%';
      var newMenupercent = '-100%';
    } else {
      var currentMenupercent = '-100%';
      var newMenupercent = '100%';
    }
  

    gsap.to(currentMenu, {
      onStart: function() { },
      left: currentMenupercent,
      duration: 0.3,
      ease: "none",
      onComplete: function() { }
    });

    gsap.set(newMenu, { left: newMenupercent })

    gsap.to(newMenu, {
      onStart: function() { },
      left:"0%",
      duration: 0.3,
      ease: "none",
      onComplete: function() { }
    });

    sessionStorage.setItem('nav_preference', radio.value);

  })
});

// Navigation Gender Toggle Function

function genderToggleInit() {
  var storageState = sessionStorage.getItem('nav_preference');
  if (!storageState) return null;

  var target = document.querySelector(".mobile-draw__nav-gender #" + storageState);
  if (!target) return null;

  target.click();
}

// Initialise Sitewide Countdowns

heroCountdown();

function heroCountdown() {
  const now = new Date();
  const newNow = new Date(now.toLocaleString('en-GB', {
    timeZone: 'Europe/London',
    dateStyle: 'medium',
    timeStyle: 'medium'
  }));

  var countdown = document.querySelectorAll('.countdown-container');

  countdown.forEach(elem => {
    var time = elem.getAttribute('data-time');
    var countDownDate = new Date(time).getTime();
    var now = newNow.getTime();
    window.time = now;

    // 👇 Define update function scoped per element
    function updateCountdown() {
      var distance = countDownDate - window.time;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var type = elem.getAttribute('data-countdown-type');

      switch (type) {
        case 'inline':
        case 'clubhouse':
          elem.querySelector('[data-content]').innerHTML = elem.getAttribute('data-content');
          elem.querySelector('[data-countdown]').innerHTML =
            ("0" + days).slice(-2) + "D " +
            ("0" + hours).slice(-2) + "H " +
            ("0" + minutes).slice(-2) + "M " +
            ("0" + seconds).slice(-2) + "S";
          break;

        default:
          elem.querySelector('[data-countdown]').innerHTML =
            ("0" + days).slice(-2) + ":" +
            ("0" + hours).slice(-2) + ":" +
            ("0" + minutes).slice(-2) + ":" +
            ("0" + seconds).slice(-2);
          break;
      }

      if (distance < 0) {
        clearInterval(x);
        switch (type) {
          case 'announcement':
            elem.querySelector('[data-countdown]').remove();
            break;
          case 'hero-image':
          case 'inline':
            elem.innerHTML = "";
            break;
          case 'clubhouse-signup':
            elem.innerHTML = "";
            var state = elem.closest('[aria-countdown]').getAttribute('aria-countdown');
            if (state == 'opens') {
              elem.closest('[aria-countdown]').setAttribute('aria-countdown', 'disabled');
            } else if (state == 'closes') {
              elem.closest('[aria-countdown]').setAttribute('aria-countdown', 'opens');
              elem.closest('[aria-countdown]').querySelector('.form-countdown span').innerHTML = theme.clubhouse.countdown_expired;
            }
            break;
          case 'clubhouse':
            elem.querySelector('[data-loaded]').removeAttribute('hidden');
            elem.querySelector('[data-content]').setAttribute('hidden', '');
            elem.querySelector('[data-countdown]').setAttribute('hidden', '');
            break;
        }
      }
    }

    // Call it immediately
    updateCountdown();

    // Then start the interval
    var x = setInterval(updateCountdown, 1000);

    setTimeout(function () {
      elem.removeAttribute('data-time');
      elem.classList.add('loaded');
    }, 1000);
  });

  // Global clock tick
  var y = setInterval(function () {
    window.time = window.time + 1000;
  }, 1000);
}


// Initialise PDP Similar Products popup

var similarToggleArray = document.querySelectorAll('.js-button-similar');

similarToggleArray.forEach(toggle => {
  toggle.addEventListener('click', function () {
    document.getElementById('product_similar').classList.toggle("active");
    document.querySelector('html').classList.toggle("no-scroll");
    });
});

// Function to check if element is in Viewport

function isInViewport(element) {

  var bounding = element.getBoundingClientRect();
  
  if (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  ) {
      return true;
  } else {
      return false;
  }
}

// PLP Mobile Slider

function prodSliderInit() {
  var elms = document.querySelectorAll( '.mobile_image-snap' );
  for ( var i = 0; i < elms.length; i++ ) {
    new Splide( elms[ i ] ).mount();
    elms[ i ].setAttribute('slider-initialised', '');
  }
}

function BISQuickbuy(event) {
  event.preventDefault();
  var buttonContainer = event.target.closest('form').querySelector('button.js-product-add');
  var variantID = event.target.closest('form').querySelector('.product-form__content input[name="id"]').value;
  var prodID = event.target.closest('form').querySelector('.product-form__content input[name="productID"]').value;
  var emailInput = event.target.closest('form').querySelector('.quick-shop-bis [type="email"]');
  var isMarketing = true;


  if (emailInput.validity.valid) {
      promise = BIS.create(emailInput.value, variantID, prodID, { accepts_marketing: isMarketing })
      buttonContainer.classList.add('is-adding');
      promise.then(function(data) {
        buttonContainer.classList.remove('is-adding');
        buttonContainer.classList.add('is-added');
        setTimeout(() => { buttonContainer.classList.remove('is-added')
        $.magnificPopup.close();
        document.querySelector('quick-shop.active .quick-shop__close').click();
        }, "1000");
      })
  }
}

function BIS_url(elem) {
  let id = elem.closest('form').querySelector('[name="id"]').value;
  let variantURL = elem.closest('quick-shop').getAttribute('data-product-url');
  var url = new URL(variantURL);
  url.searchParams.set('bis', id);
  window.location.href = url.href;
  elem.classList.add('is-adding');
}



function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

document.addEventListener("click", function(e){
  const target = e.target.closest(".collection-sidebar__filter__availability--item:not([active])"); // Or any other selector.
  const elem = document.querySelector(".collection-sidebar__item[aria-filter] input");
  if(target){
   elem.click();
  }
});

window.addEventListener('DOMContentLoaded', function(event) {
  document.querySelector('html').classList.add('js-dom-loaded');
});
